import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const Ctx = createContext(null);

export const useAuth = () => useContext(Ctx);

export const formatApiError = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("funz_token");
    if (!token) {
      setChecked(true);
      return;
    }
    axios
      .get(`${API}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      })
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("funz_token"))
      .finally(() => setChecked(true));
  }, []);

  const save = (data) => {
    localStorage.setItem("funz_token", data.token);
    setUser(data.user);
  };

  const login = async (email, password) =>
    save((await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true })).data);

  const register = async (name, email, password) =>
    save((await axios.post(`${API}/auth/register`, { name, email, password, origin: window.location.origin }, { withCredentials: true })).data);

  const logout = async () => {
    try {
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
    } catch {
      /* stateless */
    }
    localStorage.removeItem("funz_token");
    setUser(null);
  };

  return <Ctx.Provider value={{ user, checked, login, register, logout, setUser }}>{children}</Ctx.Provider>;
};
